import { axios } from '@/utils/axios';

export interface AiMediaStatus {
  available: boolean;
  code: string | null;
  launch_origin: string | null;
}

export interface AiMediaLaunch {
  launchUrl: string;
  expiresAt: string;
}

interface Response<T> { success: boolean; data: T; message: string }

// Tickets remain in this request's memory only; never persist or log the response.
export const getAiMediaStatus = () => axios.get<Response<AiMediaStatus>>('/api/ai-media/status');
export const launchAiMedia = () => axios.post<Response<AiMediaLaunch>>('/api/ai-media/launch');
